export const SUCCESS = 0;

// 课程已经支付，无需购买
export const COURSE_ALREADY_PAID = 1001;
